import { frontendURL } from '../../../../helper/URLHelper';
import SalesPartiesIndex from '../pages/SalesPartiesIndex.vue';
import SalesPartyRegistration from '../pages/SalesPartyRegistration.vue';
import { salesPermissions } from './permissions';

export const salesPartyRoutes = [
  {
    path: frontendURL(
      'accounts/:accountId/operacao-imobiliaria/vendas/:salesTransactionId/cadastro/:partyRole'
    ),
    alias: [
      frontendURL(
        'accounts/:accountId/vendas/gerar-venda/:salesTransactionId/dashboard/:partyRole'
      ),
      frontendURL(
        'accounts/:accountId/venda/gerar-venda/:salesTransactionId/dashboard/:partyRole'
      ),
    ],
    name: 'operacao_imobiliaria_vendas_cadastro_partes',
    component: SalesPartiesIndex,
    meta: { permissions: salesPermissions },
  },
  {
    path: frontendURL(
      'accounts/:accountId/operacao-imobiliaria/vendas/:salesTransactionId/cadastro/:partyRole/nova/:partyKind'
    ),
    alias: [
      frontendURL(
        'accounts/:accountId/vendas/gerar-venda/:salesTransactionId/dashboard/:partyRole/:partyKind'
      ),
      frontendURL(
        'accounts/:accountId/venda/gerar-venda/:salesTransactionId/dashboard/:partyRole/:partyKind'
      ),
    ],
    name: 'operacao_imobiliaria_vendas_cadastro_parte_nova',
    component: SalesPartyRegistration,
    meta: { permissions: salesPermissions },
  },
  {
    path: frontendURL(
      'accounts/:accountId/operacao-imobiliaria/vendas/:salesTransactionId/cadastro/:partyRole/:partyKind/:partyId'
    ),
    alias: [
      frontendURL(
        'accounts/:accountId/vendas/gerar-venda/:salesTransactionId/dashboard/:partyRole/:partyKind/:partyId'
      ),
      frontendURL(
        'accounts/:accountId/venda/gerar-venda/:salesTransactionId/dashboard/:partyRole/:partyKind/:partyId'
      ),
    ],
    name: 'operacao_imobiliaria_vendas_cadastro_parte',
    component: SalesPartyRegistration,
    meta: { permissions: salesPermissions },
  },
  {
    path: frontendURL(
      'accounts/:accountId/operacao-imobiliaria/vendas/:salesTransactionId/cadastro/:partyRole/representante/nova/:parentPartyId'
    ),
    name: 'operacao_imobiliaria_vendas_cadastro_representante_novo',
    component: SalesPartyRegistration,
    meta: { permissions: salesPermissions },
  },
  {
    path: frontendURL(
      'accounts/:accountId/operacao-imobiliaria/vendas/:salesTransactionId/cadastro/:partyRole/representante/:parentPartyId/:partyId'
    ),
    name: 'operacao_imobiliaria_vendas_cadastro_representante',
    component: SalesPartyRegistration,
    meta: { permissions: salesPermissions },
  },
  {
    path: frontendURL(
      'accounts/:accountId/vendas/gerar-venda/:salesTransactionId/dashboard/:partyRole/pessoa-juridica/:parentPartyId/representante'
    ),
    redirect: to => ({
      name: 'operacao_imobiliaria_vendas_cadastro_representante_novo',
      params: to.params,
    }),
  },
  {
    path: frontendURL(
      'accounts/:accountId/venda/gerar-venda/:salesTransactionId/dashboard/:partyRole/pessoa-juridica/:parentPartyId/representante'
    ),
    redirect: to => ({
      name: 'operacao_imobiliaria_vendas_cadastro_representante_novo',
      params: to.params,
    }),
  },
  {
    path: frontendURL(
      'accounts/:accountId/vendas/gerar-venda/:salesTransactionId/dashboard/:partyRole/pessoa-juridica/:parentPartyId/representante/:partyId'
    ),
    redirect: to => ({
      name: 'operacao_imobiliaria_vendas_cadastro_representante',
      params: to.params,
    }),
  },
  {
    path: frontendURL(
      'accounts/:accountId/venda/gerar-venda/:salesTransactionId/dashboard/:partyRole/pessoa-juridica/:parentPartyId/representante/:partyId'
    ),
    redirect: to => ({
      name: 'operacao_imobiliaria_vendas_cadastro_representante',
      params: to.params,
    }),
  },
];
